import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MetalPriceService {
  private dataUrl = '/api/prices/prices.json';
  public apiBaseUrl: string = !!environment.apiBaseUrl ? environment.apiBaseUrl : '/';

  constructor(private http: HttpClient) {}

  fetchData(metal: string, currency: string, interval: string): Observable<any> {
    const timestamp = new Date().getTime();
    const url = `${this.apiBaseUrl}/prices/prices.json?noCache=${timestamp}&version=v2&chartType=CHART_POINTS&securityId=${metal}&valuationSecurityId=${currency}&interval=${interval}&batch=Full&callback=`;

    return this.http.get(url, { responseType: 'text' }).pipe(
      map(response => {
        const cleanedResponse = response.replace(/^\(|\);?$/g, '');
        return JSON.parse(cleanedResponse);
      }),
      catchError(error => {
        console.error('API request failed', error);
        return of({ seriesData: {} });
      })
    );
  }
}
